import type { IAnalyticsEventFormField } from '@sravni/cosago-react-library/lib/types';
import { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from 'shared/lib';
import { SendEventWrapper } from 'shared/lib/sendGAEvents';
import { useUpdateStateBySelector } from 'shared/lib/useUpdateStateBySelector';

import type { TPledgeAutoFields } from 'entities/pledgeAutoForm';
import {
  PledgeAutoValidationSchema,
  selectPledgeAutoData,
  selectVehicleType,
  PledgeAutoFormFieldsTexts,
  setPledgeAutoInfo,
} from 'entities/pledgeAutoForm';

import { PledgeAutoFormViewHoc } from './FormBody';
import { FormFieldsControls } from './PledgeAutoForm.config';

type Props = Omit<IFormPopup, 'stepIndex' | 'setHeader' | 'isFormForceOpened' | 'onFormSubmit'> & {
  submitButtonText?: string;
  onFormSubmit?: (data: TPledgeAutoFields) => void;
  isRequiredCarNumber?: boolean;
};

export const PledgeAutoForm: FC<Props> = (props) => {
  const { onFormSubmit, submitButtonText, isLoading, isRequiredCarNumber } = props;
  const vehicleType = useAppSelector(selectVehicleType);
  const [formData] = useUpdateStateBySelector(selectPledgeAutoData);
  const dispatch = useAppDispatch();

  const sendAnalyticsEvent = useCallback((_: IAnalyticsEventFormField) => {
    // todo: отправка события в аналитику
  }, []);

  const handleData = async (actualData: TPledgeAutoFields, type: string) => {
    if (type === 'fullFilled') {
      dispatch(setPledgeAutoInfo({ data: actualData, isFullFilled: true }));
      onFormSubmit?.(actualData);
    }
  };

  const formLabels = useMemo(() => PledgeAutoFormFieldsTexts(vehicleType), [vehicleType]);

  return (
    <SendEventWrapper sendEvent={sendAnalyticsEvent}>
      <PledgeAutoFormViewHoc
        onDataChanged={handleData}
        defaultData={formData}
        validationSchema={PledgeAutoValidationSchema(isRequiredCarNumber)}
        formLabels={formLabels}
        formFieldsControls={FormFieldsControls}
        submitButtonText={submitButtonText}
        isLoading={isLoading}
      />
    </SendEventWrapper>
  );
};
